import { Automation, AutomationFormData, AutomationSaveRequestData } from '../types';

export function buildFormData(data?: Automation): AutomationFormData {
  return {
    id: data?.id || '',
    name: data?.name || '',
    status: data?.status || 'active',
    triggers: data?.triggers?.length
      ? data.triggers.map(t => ({
          triggerType: t.triggerType,
          targetId: t.targetId || '',
        }))
      : [{ triggerType: 'group_joined', targetId: '' }],
    actions: data?.actions?.length
      ? data.actions
          .slice()
          .sort((a, b) => a.position - b.position)
          .map(a => ({
            metadataId: a.metadataId,
            value: a.value,
            overwriteExisting: a.overwriteExisting,
          }))
      : [{ metadataId: '', value: '', overwriteExisting: true }],
  };
}

export function buildRequestData(data: AutomationFormData): AutomationSaveRequestData {
  return {
    name: data.name,
    status: data.status,
    triggers: data.triggers.map(t => ({
      triggerType: t.triggerType,
      targetId: t.triggerType === 'contact_created' ? null : t.targetId || null,
    })),
    actions: data.actions.map((a, index) => ({
      metadataId: a.metadataId,
      value: a.value,
      overwriteExisting: a.overwriteExisting,
      position: index + 1,
    })),
  };
}
